import _taggedTemplateLiteral from "/home/circleci/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n  ", "\n  ", "\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n  flex-grow: 0;\n  flex-shrink: 0;\n  width: 24px;\n  height: 24px;\n\n  overflow: hidden;\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  flex-shrink: 0;\n  width: 0.5em;\n  height: 0.8125em;\n  margin-inline-start: 0.25em;\n\n  transition: 250ms var(", ");\n  transition-property: transform, stroke;\n\n  [dir='rtl'] & {\n    transform: rotate(180deg);\n  }\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n          position: absolute;\n          inset: 0;\n        "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  pointer-events: none;\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  ", "\n\n  opacity: ", ";\n  transition: 300ms var(", ");\n  transition-property: opacity;\n  transition-delay: ", ";\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  padding-inline-end: 5px;\n\n  &[href],\n  &[type]:not(:disabled) {\n    ", " {\n      stroke: var(", ");\n    }\n\n    &:hover {\n      ", " {\n        transform: translateX(5px);\n\n        [dir='rtl'] & {\n          transform: rotate(180deg) translateX(5px);\n        }\n\n        stroke: var(", ");\n      }\n    }\n  }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n      color: var(", ");\n      background-color: var(\n        ", "\n      );\n\n      &[href],\n      &[type]:not(:disabled) {\n        color: var(", ");\n        background-color: var(\n          ", "\n        );\n\n        &:hover {\n          color: var(", ");\n          background-color: var(\n            ", "\n          );\n        }\n      }\n    "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  justify-content: center;\n  width: 100%;\n  min-width: 9em;\n  padding-block-start: 1em;\n  padding-inline-end: 2em;\n  padding-block-end: 1em;\n  padding-inline-start: 2em;\n\n  border-color: var(\n    ", "\n  );\n\n  &[href],\n  &[type]:not(:disabled) {\n    border-color: var(\n      ", "\n    );\n\n    &:hover {\n      border-color: var(\n        ", "\n      );\n    }\n  }\n\n  ", "\n\n  @media (min-width: ", ") {\n    width: ", ";\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n\n  display: inline-flex;\n  align-items: center;\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n\n  color: var(\n    ", "\n  );\n  text-align: center;\n  text-decoration: none;\n  vertical-align: middle;\n\n  background-color: transparent;\n  border: 1px solid transparent;\n  border-radius: 0;\n  outline-offset: 2px;\n\n  cursor: ", ";\n\n  transition-timing-function: var(", ");\n  transition-duration: 250ms;\n  transition-property: color, background-color, border-color;\n\n  appearance: none;\n\n  user-select: none;\n\n  &[href],\n  &[type]:not(:disabled) {\n    color: var(", ");\n\n    cursor: pointer;\n\n    user-select: initial;\n\n    &:hover {\n      color: var(", ");\n    }\n  }\n\n  ", "\n  ", "\n  ", "\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  margin-inline-start: ", ";\n\n  text-align: start;\n\n  transform: ", ";\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

/* eslint-disable-next-line import/named */
import styled, { css } from 'styled-components';
import { injectTypography } from '../../utils/injectTypography';
import { injectOSXFontSmoothing } from '../../utils/injectOSXFontSmoothing';
import { injectSpacing } from '../../api/spacing/injectSpacing';
export var AUTO_WIDTH_BREAKPOINT = '440px';
export var StyledButtonLabel = styled.span(_templateObject(), function (props) {
  return props.icon && "var(".concat(props.theme.responsive.spacing.s, ")");
}, function (props) {
  return props.size === 'small' && 'translateY(0.05em)';
}, function (props) {
  return injectOSXFontSmoothing(props.size !== 'small');
}); // All buttons are styled as disabled, then other styles are applied if an `href` attribute is present or the button is discovered not to be disabled.

export var injectCommonButtonStyles = function injectCommonButtonStyles(props) {
  return css(_templateObject2(), props.isLoading ? props.theme.colors.interaction.primary.default : props.theme.colors.interaction.primary.disabled, props.isLoading ? 'progress' : 'not-allowed', props.theme.easing, props.theme.colors.interaction.primary.default, props.theme.colors.interaction.primary.hover, injectSpacing('margin'), injectTypography(props, props.size === 'small' ? 'copy2' : 'copy1'), injectOSXFontSmoothing(true));
};
export var injectBlockButtonStyles = function injectBlockButtonStyles() {
  return css(_templateObject3(), function (props) {
    return props.isLoading ? props.theme.colors.interaction.primary.default : props.theme.colors.interaction.primary.disabled;
  }, function (props) {
    return props.theme.colors.interaction.primary.default;
  }, function (props) {
    return props.theme.colors.interaction.primary.hover;
  }, function (props) {
    return props.variant === 'primary' && css(_templateObject4(), props.theme.colors.ui.inverted, props.isLoading ? props.theme.colors.interaction.primary.default : props.theme.colors.interaction.primary.disabled, props.theme.colors.ui.inverted, props.theme.colors.interaction.primary.default, props.theme.colors.ui.inverted, props.theme.colors.interaction.primary.hover);
  }, AUTO_WIDTH_BREAKPOINT, function (props) {
    return props.stretch ? '100%' : 'auto';
  });
};
export var injectTextButtonStyles = function injectTextButtonStyles() {
  return css(_templateObject5(), StyledArrow, function (props) {
    return props.theme.colors.interaction.primary.default;
  }, StyledArrow, function (props) {
    return props.theme.colors.interaction.primary.hover;
  });
};
export var StyledTransitionContainer = styled.div(_templateObject6(), function (props) {
  return props.overlay ? css(_templateObject7()) : '';
}, function (props) {
  return props.visible ? '1' : '0';
}, function (props) {
  return props.theme.easing;
}, function (props) {
  return props.visible ? '300ms' : '0';
});
export var StyledArrow = styled.svg(_templateObject8(), function (props) {
  return props.theme.easing;
});
export var StyledIconContainer = styled.div(_templateObject9());
export var StyledButton = styled.button(_templateObject10(), injectCommonButtonStyles, function (props) {
  switch (props.variant) {
    case 'primary':
    case 'secondary':
      return injectBlockButtonStyles();

    case 'text':
      return injectTextButtonStyles();
  }
});